export default [
  {
    path: '/native-talk',
    component: () => import('./views/Index'),
    name: 'native-talk',
    redirect: { name: 'native-talk-list' },
    children: [
      {
        path: '',
        name: 'native-talk-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'social-plus',
        },
      },
    ],
  },
]
